// @flow

import { css } from 'styled-components';

const center = css`
  align-items: center;
`;

const top = css`
  align-items: flex-start;
`;

const bottom = css`
  align-items: flex-end;
`;

export default (position: string) => {
  switch (position) {
    case 'top':
      return top;
    case 'center':
      return center;
    case 'bottom':
      return bottom;
    default:
      return null;
  }
};
